import { useState } from "react";
import { MOOD_META } from "../lib/moods";

export default function useSessionForm() {
  const [selectedMood, setSelectedMood] = useState(null);
  const [customMood, setCustomMood] = useState("");
  const [blendOn, setBlendOn] = useState(false);
  const [mood2, setMood2] = useState(null);
  const [blend, setBlend] = useState(50);
  const [duration, setDuration] = useState(30);
  const [excludeRecent, setExcludeRecent] = useState(false);

  const activeMood2 = blendOn && mood2 && mood2 !== selectedMood ? mood2 : null;
  const moodName = selectedMood === "custom" ? customMood.trim() || "Mon mood" : MOOD_META[selectedMood]?.name;

  const error = !selectedMood
    ? "Choisis un mood d'abord"
    : selectedMood === "custom" && !customMood.trim()
      ? "Écris ton mood d'abord"
      : null;

  const cfg = {
    mood: selectedMood === "custom" ? null : selectedMood,
    custom_mood: selectedMood === "custom" ? customMood.trim() : null,
    mood2: activeMood2,
    blend,
    duration_minutes: duration,
    exclude_recent: excludeRecent,
  };

  const applyCfg = (c) => {
    setSelectedMood(c.custom_mood ? "custom" : c.mood);
    setCustomMood(c.custom_mood || "");
    setBlendOn(!!c.mood2);
    setMood2(c.mood2 || null);
    setBlend(c.blend || 50);
    setDuration(c.duration_minutes);
    setExcludeRecent(!!c.exclude_recent);
  };

  return {
    selectedMood, setSelectedMood, customMood, setCustomMood, blendOn, setBlendOn,
    mood2: activeMood2, setMood2, blend, setBlend, duration, setDuration,
    excludeRecent, setExcludeRecent, moodName, error, cfg, applyCfg,
  };
}
